import { IEvent } from "@quest/adapter-interface";
import { ingenuity, IObject } from "@quest/base-core";
import {
  BaseViewBehavior
} from "@quest/murka-games-behavior-panther";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class GrandOutroView extends BaseViewBehavior {
  public jackpotName: string;

  constructor(viewJson: IObject) {
    super(viewJson);
    this.CurrentOrientation = "";
  }
  // /**
  //  * add view on top
  //  */
  // public addOnTop(): void {
  //   ingenuity.currentGame.stage.addChild(this);
  // }

  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
      let scale = 0;
      this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);
      scale = Math.max(innerHeight / ingenuity.configData.width, innerWidth / ingenuity.configData.height);
      this.scale.set(scale);
    }
  }
}
